import React from 'react';
import NavBar from '../components/NavBar';
import Section1 from '../components/section1';
import Footer from '../components/Footer';
import Services from '../components/Services';

function Home( ){
    return (
        <>
        <NavBar/>
        <Section1/>
        <Services/>
        <Footer/>
        </>
        
    )
}

export default Home